<template>
    <div class="position-box">
        <ul class="head-tab-box">
            <li class="tab tab1" @click="link(1)">{{$t('jghy.jghy')}}</li>
            <li class="tab tab3" @click="link(2)">{{$t('jghy.yxhy')}}</li>
            <li class="tab tab2 active">{{$t('footer.currency')}}</li>
        </ul>
        <div class="transaction-head">
            <img class="icon" v-if="!theme" src="@/assets/More.png" @click="leftShow" alt="">
            <img class="icon" v-else src="@/assets/trend_tabulate.png" @click="leftShow" alt="">
            <div class="text">{{symbol}}</div>
            <img class="icon" v-if="!theme" src="@/assets/Trend.png" alt="" @click="kline(symbol,leftIdx)">
            <img class="icon" v-else src="@/assets/theme/hangqing.png" alt="" @click="kline(symbol,leftIdx)">
        </div>
        <div class="scroll-box">
            <div class="item1-box">
                <div class="icon icon1" :class="{active: tradeIdx == 1}" @click="trade(1)">{{$t('bbjy.mr')}}</div>
                <div class="icon icon2" :class="{active: tradeIdx == 2}" @click="trade(2)">{{$t('bbjy.mc')}}</div>
                <div class="item1-right">
                    <p class="t2" :class="[ Number(increase) < 0 ?'red':'green']" v-show="increase">{{increase}}%</p>
                    <p class="t1" :class="[ Number(increase) < 0 ?'red':'green']">{{curPrice | toFixed}}</p>
                </div>
            </div>
            <div class="transaction-box">
                <div class="transaction-left">
                    <div class="limit-box" v-if="lang == 'ar'" @click="alertType">
                        <img class="icon" style="margin: 0 .24rem 0 0" src="@/assets/down.png" alt="">
                        <div>{{priceText}}</div>
                    </div>
                    <div class="limit-box" v-else @click="alertType">
                        <div>{{priceText}}</div>
                        <img class="icon" src="@/assets/down.png" alt="">
                    </div>
                    <div class="num-wrap" v-show="curPriceType == 0">
                        <div class="input-box xianjia"><input class="input" type="text" @keyup="keyXianjia" v-model="xianjia"></div>
                        <div class="num-box">
                            <button class="btn" type="button" @click="jian">-</button>
                            <button class="btn" type="button" @click="add">+</button>
                        </div>
                    </div>
                    <div class="price-box" v-show="curPriceType == 1"><input class="input" type="text" disabled readonly :placeholder="$t('bbjy.scjg')"></div>
                    <div class="table">
                        <div class="table-head" v-if="lang == 'ar'">
                            <div>{{symbol}}</div>
                            <div class="num-box" v-show="tradeIdx == 1"><input type="number" class="input number" v-model="account"  min="0" :placeholder="placeholder" @keyup="keyMoney()" ></div>
                            <div class="num-box" v-show="tradeIdx == 2"><input type="number" class="input number" v-model="account" @keyup="keyMoney()"  min="0" :placeholder="$t('bbjy.scjg')"></div>
                        </div>
                        <div class="table-head" v-else>
                            <div class="num-box" v-show="tradeIdx == 1"><input type="number" class="input number" v-model="account"  min="0" :placeholder="placeholder" @keyup="keyMoney()" ></div>
                            <div class="num-box" v-show="tradeIdx == 2"><input type="number" class="input number" v-model="account" @keyup="keyMoney()"  min="0" :placeholder="$t('bbjy.scjg')"></div>
                            <div>{{symbol}}</div>
                        </div>
                    </div>
                    <ul class="percent-box">
                        <li class="percent" :class="{active: percentIdx == 0}" @click="percent(0,'0%')"></li>
                        <li class="percent" :class="{active: percentIdx == 1}" @click="percent(1,'25%')"></li>
                        <li class="percent" :class="{active: percentIdx == 2}" @click="percent(2,'50%')"></li>
                        <li class="percent" :class="{active: percentIdx == 3}" @click="percent(3,'75%')"></li>
                        <li class="percent" :class="{active: percentIdx == 4}" @click="percent(4,'100%')"></li>
                    </ul>
                    <div class="percent-text">{{percentVal}} {{currency}}</div>
                    <div class="price mt5" v-show="tradeIdx == 1"><span>{{$t('bbjy.ky')}}</span> {{useBalance}} {{moneyUsdt}}</div>
                    <div class="price mt5" v-show="tradeIdx == 1 && xianjia"><span>{{$t('bbjy.km')}}</span> {{(useBalance / xianjia).toFixed(4) }} {{currency}}</div>
                    <div class="price mt5" v-show="tradeIdx == 2"><span>{{$t('bbjy.ksell')}}</span> {{positions}} {{moneyUnit}}</div>
                    <div class="price mt5" v-show="tradeIdx == 2"><span>≈</span> {{(positions * xianjia).toFixed(4)}} {{moneyUsdt}}</div>
                    <div class="price mt5"><span>{{$t('jghy.sxfl')}}</span> {{deal_rate}}</div>
                    <div class="trade" v-if="lang == 'en'"><span>{{$t('bbjy.jye')}}</span> {{tradeAccount}}</div>
                    <div class="trade" v-else><span>{{$t('bbjy.jye')}}</span> {{tradeAccount}}</div>
                    <button class="btn-buy" v-show="tradeIdx == 1" type="button" @click="buy">{{$t('bbjy.mr')}}</button>
                    <button class="btn-buy btn-sell" v-show="tradeIdx == 2" type="button" @click="sellOut">{{$t('bbjy.mc')}}</button>
                </div>
                <div class="transaction-right">
                    <ul class="ul-box">
                        <li class="list">{{$t('bbjy.pk')}}</li>
                        <li class="list">{{$t('bbjy.jg')}}</li>
                        <li class="list list-qty">{{$t('bbjy.sl')}}</li>
                    </ul>
                    <ul class="cont1-box">
                        <li class="cont" v-for="(item,index) in sellArr" :key="index">
                            <div class="item">{{item.title}}</div>
                            <div class="item">{{item.price}}</div>
                            <div class="item item-number">{{item.number}}</div>
                            <div class="scroll" :style="{'width': (((item.number * item.price) /8000)  > 100 ? '100%' : ((item.number * item.price) /8000) +  Math.floor(Math.random()*25) +'%')}"></div>
                        </li>
                    </ul>
                    <div class="line"></div>
                    <ul class="cont1-box">
                        <li class="cont cont2" v-for="(item,index) in buyArr" :key="index">
                            <div class="item">{{item.title}}</div>
                            <div class="item">{{item.price}}</div>
                            <div class="item item-number">{{item.number}}</div>
                            <div class="scroll2" :style="{'width': (((item.number * item.price) /8000)  > 100 ? '100%' : ((item.number * item.price) /8000) + Math.random()*25 + '%')}"></div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="transaction-foot">
                <ul class="tab-box">
                    <li class="tab" :class="{active: tabIdx == 0}" @click="tab(0)">{{$t('bbjy.dqwt')}}</li>
                    <li class="tab" :class="{active: tabIdx == 1}" @click="tab(1)">{{$t('bbjy.lswt')}}</li>
                    <li class="tab" :class="{active: tabIdx == 2}" @click="tab(2)">{{$t('bbjy.jj')}}</li>
                </ul>
                <ul class="cont-box transaction" v-show="tabIdx == 0 || tabIdx == 1" @scroll="listenScroll">
                    <li class="list" v-for="(item,index) in wetTuoData" :key="index">
                        <div class="list-head">
                            <div class="buy" v-if="item.mark == 1">{{$t('bbjy.mai')}}</div>
                            <div class="buy sell" v-if="item.mark == 2">{{$t('bbjy.sell')}}</div>
                            <div class="type">{{item.currency}}<span>/USDT</span></div>
                            <div class="date">{{item.time | subStr1}}</div>
                            <div class="time">{{item.time | subStr2}}</div>
                            <div class="status" v-if="item.status == 2">{{$t('bbjy.ycd')}}</div>
                            <div class="status" v-else-if="item.status == 1">{{$t('bbjy.ywc')}}</div>
                            <div class="btn-cancle" v-else @click="cancelOrder(index,item.id)">{{$t('bbjy.cd')}}</div>
                        </div>
                        <div class="list-body">
                            <div class="list-item">
                                <div class="list-item-left">
                                    <div><span>{{$t('bbjy.wtzl')}}</span> {{item.amount}}</div>
                                    <div><span>{{$t('bbjy.wtjg')}}</span> {{item.price}}</div>
                                </div>
                                <div class="list-item-right">
                                    <div><span>{{$t('bbjyNew.jyze')}}</span> {{item.total}}</div>
                                    <div><span>{{$t('jghy.sxfl')}}</span> {{item.fee}}</div>
                                </div>
                                <div class="list-item-right">
                                    <div><span>{{$t('bbjyNew.jylx')}}</span> {{item.price_type | priceType}}</div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <!-- 暂无数据 -->
                    <div class="null-box" v-show="isNoData">
                        <img class="icon" v-if="!theme" src="@/assets/Null.png" alt="">
                        <img class="icon" v-else src="@/assets/theme/wushuju.png" alt="">
                        <p class="text">{{$t('zwsj.title')}}</p>
                    </div>
                </ul>
                <div class="cont-box transaction" v-show="tabIdx == 2">
                    <div class="cont1">{{message.message}}</div>
                    <div class="cont2">
                        <ul class="ul-box" v-if="lang == 'ar'">
                            <li class="li">
                                <div class="t2">{{message.issue_time}}</div>
                                <div>{{$t('bbjy.fhsj')}}</div>
                            </li>
                            <li class="li">
                                <div class="t2">{{message.issue_number}}</div>
                                <div>{{$t('bbjy.fhsl')}}</div>
                            </li>
                            <li class="li" v-show="message.white_book">
                                <div class="t2"><a :href="message.white_book" style="color: #218adc" target="_blank">{{$t('kxt.djck')}}</a></div>
                                <div>{{$t('bbjy.bps')}}</div>
                            </li>
                            <li class="li">
                                <div class="t2"><a :href="message.weburl">{{message.weburl}}</a></div>
                                <div>{{$t('bbjy.gw')}}</div>
                            </li>
                        </ul>
                        <ul class="ul-box" v-else>
                            <li class="li">
                                <div>{{$t('bbjy.fhsj')}}</div>
                                <div class="t2">{{message.issue_time}}</div>
                            </li>
                            <li class="li">
                                <div>{{$t('bbjy.fhsl')}}</div>
                                <div class="t2">{{message.issue_number}}</div>
                            </li>
                            <li class="li">
                                <div>{{$t('bbjy.bps')}}</div>
                                <div class="t2" v-show="message.white_book"><a :href="message.white_book" style="color: #218adc" target="_blank">{{$t('kxt.djck')}}</a></div>
                            </li>
                            <li class="li">
                                <div>{{$t('bbjy.gw')}}</div>
                                <div class="t2"><a :href="message.weburl">{{message.weburl}}</a></div>
                            </li>
                        </ul>
                    </div>
                    <!-- 暂无数据 -->
                    <div class="null-box" v-show="isjjNoData">
                        <img class="icon" v-if="!theme" src="@/assets/Null.png" alt="">
                        <img class="icon" v-else src="@/assets/theme/wushuju.png" alt="">
                        <p class="text">{{$t('zwsj.title')}}</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- 左侧弹框  -->
        <div class="alert-left" v-show="isLeftShow">
            <ul class="tab-box">
                <li class="tab" :class="{active: tabLeftIdx == 0}" @click="tabLeft(0)">{{$t('bbjy.zx')}}</li>
                <li class="tab" :class="{active: tabLeftIdx == 1}" @click="tabLeft(1)">USDT</li>
            </ul>
            <ul class="ul-box">
                <li class="list" :class="{active: item.symbol == symbol}" v-for="(item,index) in leftData" :key="item.id" @click="leftClick(index,item.name,item.symbol,item.type)">
                    <div class="list-box">
                        <div class="t1">{{item.name}}/<span>USDT</span></div>
                        <div class="price" :class="{green: item.change > 0}">{{item.new_price | toFixed}}</div>
                    </div>
                </li>
            </ul>
        </div>
        <!-- 限价0，市价1弹窗 -->
        <div class="alert-box currencyTrading" v-show="isShow">
            <div class="alert-item xj" :class="{active: curPriceType == 0}" @click="select(priceType[0],0)">{{priceType[0]}}</div>
            <div class="alert-item" :class="{active: curPriceType == 1}" @click="select(priceType[1],1)">{{priceType[1]}}</div>
            <div class="alert-item btn-cancle" @click="cancle">{{$t('bbjy.qx')}}</div>
        </div>
        <div class="mask" v-show="isMask" @click="cancle"></div>
        <nav-bar :navName="'currencyTrading'"></nav-bar>
    </div>
</template>

<script>
import navBar from '@/components/NavBar.vue'
let that = this;
export default {
    name: 'currencyTrading',
    data () {
        return {
            lang: 'en',
            isShow: false,
            isLeftShow: false,
            isMask: false,
            isNoData: false,
            isjjNoData: false,
            tradeIdx: 1,
            tabIdx: 0,
            leftIdx: 0,
            tabLeftIdx: 1,
            priceText: '',
            account:'',
            xianjia: '',
            curPrice: '',
            account: '',//买入量
            placeholder: '',
            moneyUnit: '',//卖出币种单位
            moneyUsdt: '',//买入币中单位
            priceType: [],
            curPriceType: 1,//0限价1市价
            currency: 'BTC',
            symbol: '',
            mark: 1,//买入
            wt: 10,//当前委托
            sellArr: [],//右侧前五条数据
            buyArr: [],//右侧后五条数据
            leftData: [],
            message: {},
            wetTuoData: [],
            useBalance: '',//用户可用余额
            positions: '',//用户卖出数量
            tradeAccount: '',//用户交易额,
            curDataLength: 10,
            websock: null,
            timer: null,
            weiTuoTimer: null,
            deal_rate: '',
            lot: 1,
            page: 1,
            limit: 10,
            isScroll: false,//是否滚动到底部
            mai: '',
            sell: '',
            wtzl: '',
            wtjg: '',
            cd: '',
            jyze: '',
            increase: '',
            currencyList: [],
            percentIdx: 0,
            percentVal: '0%',
            theme: false
        }
    },
    beforeCreate(){
        that = this;
    },
    created(){
        this.theme = JSON.parse(localStorage.getItem('theme'));
        this.tradeIdx = this.$route.query.tradeIdx || 1;
        this.currency = this.$route.query.currency || 'BTC';
        this.symbol = this.$route.query.symbol;
        this.leftIdx = this.$route.query.leftIdx;
        this.mai = this.$t('bbjy.mai');
        this.sell = this.$t('bbjy.sell');
        this.cd = this.$t('bbjy.cd');
        this.lang = localStorage.getItem('language') || 'en';
    },
    mounted() {
      let that = this;
      that.priceText = this.$t('hyjy.sj');
      that.priceType = [this.$t('hyjy.xj'),this.$t('hyjy.sj')];
      let params = {
          id: 1
      }
      this.$ajax.get('/web/getmarketList',{params}).then((res) => {
          let resData = res.data.data;
          if(res.data.code == 1000){
            setTimeout(()=>{
              this.$router.push('/login');
            },1000)
            return false
          }
          if(that.symbol == '' || that.symbol == null){
              that.currency = resData[0].currency;
              that.symbol = resData[0].symbol;
              that.getCurrency();//获取最新价和涨幅
              that.getInfo();//请求可以余额
              that.getCurPrice();//获取当前价格
              that.getWeiTuo();//获取委托
              that.initWebSocket();
              that.getmarketList();//获取币种
              that.timer = setInterval(() => {
                  that.getCurrency();
              }, 2000);
              that.weiTuoTimer = setInterval(() => {
                  that.getWeiTuo();
              }, 2000);
          }else{
              that.getCurrency();//获取最新价和涨幅
              that.getInfo();//请求可以余额
              that.getCurPrice();//获取当前价格
              that.getWeiTuo();//获取委托
              that.initWebSocket();
              that.getmarketList();//获取币种
              that.timer = setInterval(() => {
                  that.getCurrency();
              }, 2000);
              that.weiTuoTimer = setInterval(() => {
                  that.getWeiTuo();
              }, 2000);
          }
      }).catch(function(err){
          console.log(err)
      })
    },
    methods: {
      link(id){
        if(id == 1){
          this.$router.push({ path: '/contractTransaction', query: { symbol: this.symbol,jy: 2,leftIdx: this.leftIdx } })
        }else if(id == 2){
          this.$router.push({ path: '/perpetualContract', query: { symbol: this.symbol,jy: 2,leftIdx: this.leftIdx } })
        }
      },
        kline(symbol){
          this.$router.push({ path: '/kline', query: { symbol: symbol,jy: 1,leftIdx: this.leftIdx } })
        },
        percent(idx,percent){
            this.percentIdx = idx;
            this.percentVal = percent;
            if(this.tradeIdx == 1){
                this.account = ((this.useBalance * percent.split('%')[0]) / (100 * this.xianjia)).toFixed(4);
            }else{
                this.account = ((this.positions * percent.split('%')[0]) / 100).toFixed(4);
            }
        },
        getmarketList(){
            let that = this;
            let params = {
                id: that.tabLeftIdx
            }
            this.$ajax.get('/web/getmarketList',{params}).then((res) => {
                let resData = res.data.data;
                var curr;
                that.leftData = resData;
                that.currencyList = [];
                for (curr in resData){
                    that.currencyList[that.leftData[curr].currency_name.toLowerCase()] = [that.leftData[curr].icon,that.leftData[curr].symbol] ;
                }
            }).catch(function(err){
                console.log(err)
            })
        },
        initWebSocket(){ //初始化weosocket
            const wsuri = this.socket_url;
            this.websock = new WebSocket(wsuri);
            this.websock.onmessage = this.websocketonmessage;
            this.websock.onopen = this.websocketonopen;
            this.websock.onerror = this.websocketonerror;
            this.websock.onclose = this.websocketclose;
        },
        websocketonopen(){ //连接建立之后执行send方法发送数据

        },
        websocketonerror(){//连接建立失败重连
            this.initWebSocket();
        },
        websocketonmessage(e){ //数据接收
            if(JSON.parse(e.data).action == "marketprice"){
                let currency = this.currency.toLowerCase();
                let msg = JSON.parse(e.data).content;
                let daymarket = msg[currency];

                this.curPrice = daymarket.now_price;
                this.increase = daymarket.change;
                let keyArr = [];
                for(var x in this.currencyList){
                    for(var y in this.leftData){
                      if(!msg[x]) return;
                      if(msg[x].currency_name == this.leftData[y].currency_name){
                          this.leftData[y]['new_price'] = msg[x].now_price;
                          this.leftData[y]['change'] = msg[x].change;
                          keyArr.push(this.leftData[y]);
                          break;
                      }
                    }
                }
                this.leftData = keyArr;
            }
        },
        websocketsend(Data){//数据发送
            this.websock.send(Data);
        },
        websocketclose(e){  //关闭
        },
        getCurPrice(){
            let that = this;
            let params = {
                id: 1,
                symbol: that.symbol,
            }
            this.$ajax.get('/web/getmarketList',{params}).then((res) => {
                let resData = res.data.data;
                that.newprice = resData[0].new_price;
                that.xianjia =  resData[0].new_price;
            }).catch(function(err){
                console.log(err)
            })
        },
        getCurrency(){
            let that = this;
            let params = {
                currency: that.currency,
                type: 1,
            }
            this.$ajax.get('/web/getCurrencyPriceAndIncrease',{params}).then((res) => {
                let resData = res.data.data;
                let xianjiaArr = resData.value.split(",");
                if(that.symbol == '' || that.symbol == null){
                    that.currency = resData.price[0].name;
                    that.symbol = resData.price[0].symbol;
                }
                var str = resData.deal;
                var value = resData.value;

                if (typeof (str) === 'object') {
                    value = str.value
                    str = str.deal
                }

                var arr = str.split(",");

                var start = 1;
                var len = 5;
                var sell = [];
                for (; ; start += 2) {
                    sell.push({
                        title: len,
                        price: that.toFixed(arr[start]),
                        number: that.toFixed(arr[start + 1])
                    });
                    len--;
                    if (len == 0) break;
                }
                that.sellArr = sell;
                start = 11;
                var len = 1;
                var buy = [];
                for (; ; start += 2) {
                    buy.push({
                        title: len,
                        price: that.toFixed(arr[start]),
                        number: that.toFixed(arr[start + 1])
                    });
                    len++;
                    if (len == 6) break;
                }
                that.buyArr =  buy;
            }).catch(function(err){
                console.log(err)
            })
        },
        getInfo(){
            let that = this;
            let params = {
              type:1,
              currency: that.currency,
            }
            this.$ajax.get('/web/getInfo',{params}).then((res) => {
                let resData = res.data.data;
                if(res.data.code == 1000){
                  setTimeout(()=>{
                    this.$router.push('/login');
                  },1000)
                  return false
                }
                that.useBalance =  (Number(resData.wallet.usdt)).toFixed(4);
                that.positions =  (Number(resData.wallet.positions)).toFixed(4);
                that.lot = resData.lot;
                that.placeholder = that.$t('tipsNew.zdsl') + resData.lot;
                that.deal_rate = resData.deal_rate + '%'
                that.moneyUsdt = resData.usdt
                that.moneyUnit = resData.unit
            }).catch(function(err){
                console.log(err)
            })
        },
        getWeiTuo(){
            let that = this;
            let params = {
              currency: that.currency,
              limit: that.limit,
              page: that.page,
              mark: that.mark,
              type: 1,
              wt: that.wt,
            }
            this.$ajax.get('/web/getWeiTuo',{params}).then((res) => {
                let resData = res.data.data;
                if(resData.list.length > 0){
                    if(that.isScroll){
                        that.wetTuoData = that.wetTuoData.concat(resData.list);
                    }else{
                        that.wetTuoData = resData.list;
                    }
                    that.curDataLength = resData.list.length;
                }else{
                    clearInterval(that.weiTuoTimer);
                    that.weiTuoTimer = null;
                    that.wetTuoData = resData.list;
                    that.curDataLength = resData.list.length;
                }
                if(that.wetTuoData.length > 0){
                    that.isNoData = false;
                }else{
                    that.isNoData = true;
                }
            }).catch(function(err){
                console.log(err)
            })
        },
        getMessage(){//获取简介
            let that = this;
            let params = {
              currency: that.currency,
              token: 1
            }
            this.$ajax.get('/web/getCurrencyMessage',{params}).then((res) => {
                let resData = res.data.data;
                if(resData == null){
                    that.message = {};
                    that.isjjNoData = true
                }else{
                    that.message = resData;
                    that.isjjNoData = false
                }
            }).catch(function(err){
                console.log(err)
            })
        },
        listenScroll(e) {  //监听滚动
            let ele = e.srcElement ? e.srcElement : e.target;
            if (ele.scrollTop + ele.offsetHeight >= ele.scrollHeight) { //监听滚动到div底部
                if(this.curDataLength >= this.limit){
                    this.isScroll = true
                    this.page ++;
                    this.getWeiTuo();
                }else{
                    this.isScroll = false
                }
            }
        },
        leftClick(idx,name,symbol,type){//左侧币种选择
            this.leftIdx = idx;
            this.currency = name;
            this.symbol = symbol;
            this.isLeftShow = false;
            this.isMask = false;
            this.account = '';
            this.account = '';
            this.percentIdx = 0;
            this.percentVal = '0%';
            this.tradeAccount = '';
            this.wetTuoData = [];
            this.page = 1;
            this.isScroll = false;
            this.getCurPrice();
            this.getCurrency();
            this.getInfo();
            this.getWeiTuo();
            this.getMessage();
            if(type != 1){
              this.$router.push({ path: '/preciousMetal', query: { symbol: symbol } })
            }
        },
        jian(){
            var num = Number(this.xianjia);
            num = (num * 10 * 10 * 10 * 10);
            num -= 1;
            num = ((Number(num)) / 10000).toFixed(4)
            if (num <= 0) {
                num = 0;
            }
            this.xianjia = num;
        },
        add(){
            var num = Number(this.xianjia);
            num = (num * 10 * 10 * 10 * 10);
            num += 1;
            num = ((Number(num)) / 10000).toFixed(4)
            this.xianjia = num;
        },
        buy(){//买入
            let that = this;
            if(that.xianjia == '' || that.xianjia <= 0){
                this.$toast.center(this.$t('xbsg.qsrsl'));
                return false;
            }
            if(that.account == ''){
                this.$toast.center(this.$t('xbsg.qsrsl'));
                return false;
            }else if(that.account < that.lot){
                layer_msg(this.$t('tipsNew.sldydy') + ' '+ that.lot);
                return false;
            }
            let params = {
              price: that.xianjia,
              amount: that.account,
              price_type: that.curPriceType,
              mark: 1,
              currency: that.currency,
              deal_type: 1,
            }
            this.$ajax.post('/web/createOrder',params).then((res) => {
                let resData = res.data;
                if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                    that.account = '';
                    that.account = '';
                    that.percentIdx = 0;
                    that.percentVal = '0%';
                    that.$toast.center(resData.message);
                    that.getInfo();
                    if(that.tabIdx == 1){
                        setTimeout(() => {
                            that.getWeiTuo();
                        },3000)
                    }else{
                        that.getWeiTuo();
                    }
                }else{
                    this.$toast.center(resData.message);
                    return;
                }
            }).catch(function(err){
                console.log(err)
            })
        },
        sellOut(){//卖出
            let that = this;
            if(that.xianjia == '' || that.xianjia <= 0){
                this.$toast.center(this.$t('xbsg.qsrsl'));
                return false;
            }
            if(that.account == ''){
                this.$toast.center(this.$t('xbsg.qsrsl'));
                return false;
            }else if(that.account < that.lot){
                layer_msg(this.$t('tipsNew.sldydy') + ' '+ that.lot);
                return false;
            }
            var params = {
                price: that.xianjia,
                amount: that.account,
                price_type: that.curPriceType,
                mark: 2,
                currency: that.currency,
                deal_type: 1,
            }
            that.account = '';
            this.$ajax.post('/web/createOrder',params).then((res) => {
                let resData = res.data;
                if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                    that.account = '';
                    that.percentIdx = 0;
                    that.percentVal = '0%';
                    that.getInfo();
                    that.$toast.center(resData.message);
                    if(that.tabIdx == 1){
                        setTimeout(() => {
                            that.getWeiTuo();
                        },3000)
                    }else{
                        that.getWeiTuo();
                    }
                }else{
                    this.$toast.center(resData.message);
                    return;
                }
            }).catch(function(err){
                console.log(err)
            })
        },
        cancelOrder(idx,id){//撤单
            let params = {
              id: id
            }
            this.wetTuoData.splice(idx,1);
            this.$ajax.post('/web/orderCancel',params).then((res) => {
                let resData = res.data;
                if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                    this.getWeiTuo();
                }else{
                    this.$toast.center(resData.message);
                    return;
                }
            }).catch(function(err){
                console.log(err)
            })
        },
        toFixed(v) {
            return parseFloat(v).toFixed(4)
        },
        alertType(){
            this.isShow = true;
            this.isMask = true;
        },
        select(obj,curPriType){
            this.priceText = obj;
            this.curPriceType = curPriType;
            this.getInfo();
            this.isShow = false;
            this.isMask = false;
        },
        leftShow(){
            this.isLeftShow = true;
            this.isMask = true;
        },
        trade(idx){
            this.tradeIdx = idx;
            this.mark = idx;
            this.account = '';
            this.percentIdx = 0;
            this.percentVal = '0%';
            if(this.tabIdx == 1){
                this.wt = 12;
            }else{
                if(idx == 1){
                    this.wt = 10;
                }else{
                    this.wt = 11;
                }
            }
            this.wetTuoData = [];
            this.getInfo();
            this.getWeiTuo();

        },
        tab(idx){
            this.tabIdx = idx;
            this.wetTuoData = [];
            if(idx == 0){
                if(this.tradeIdx == 1){
                    this.wt = 10;
                }else{
                    this.wt = 11;
                }
                this.getWeiTuo();
                this.weiTuoTimer = setInterval(() => {
                    this.getWeiTuo();
                }, 2000);
            }else if(idx == 1){
                this.wt = 12;
                this.page = 1;
                this.isScroll = false;
                clearInterval(this.weiTuoTimer);
                this.getWeiTuo();
            }else{
                this.isNoData = false;
                this.getMessage();
            }
        },
        tabLeft(idx){
            this.leftData = [];
            this.tabLeftIdx = idx;
            this.getmarketList();
        },
        cancle(){
            this.isShow = false;
            this.isLeftShow = false;
            this.isMask = false
        },
        keyMoney(){
          this.account = this.account.replace(/[^\d.]/g, "");  //仅保留数字和"."
          this.account = this.account.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
          this.account = this.account.replace(".", "$#*").replace(/\./g,'').replace('$#*','.');//去除其他"."
          this.account = this.account.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2');;//限制只能输入两个小数
          if (this.account.indexOf(".") < 0 && this.account != "") { //首位是0的话去掉
              this.account = parseFloat(this.account);
          }
        },
        keyXianjia(){
          this.xianjia = this.xianjia.replace(/[^\d.]/g, "");  //仅保留数字和"."
          this.xianjia = this.xianjia.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
          this.xianjia = this.xianjia.replace(".", "$#*").replace(/\./g,'').replace('$#*','.');//去除其他"."
          this.xianjia = this.xianjia.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2');;//限制只能输入两个小数
          if (this.xianjia.indexOf(".") < 0 && this.xianjia != "") { //首位是0的话去掉
              this.xianjia = parseFloat(this.xianjia);
          }
        }
    },
    components:{
        navBar,
    },
    watch: {
        account(){
            return this.tradeAccount = (this.xianjia * this.account).toFixed(4);
        }
    },
    filters:{
        subStr1(val){
            return val.substring(5, 10);
        },
        subStr2(val){
            return val.substring(11, 19);
        },
        toFixed: function (value) {
            if(!value) return;
            value = Number(value);
            return value.toFixed(4);
        },
        priceType(val){
            if(val == 0){
                return that.$t('bbjy.xj')
            }else{
                return that.$t('bbjy.sj')
            }
        }
    },
    beforeDestroy(){
        clearInterval(this.timer);
        clearInterval(this.weiTuoTimer);
        this.timer = null;
        this.weiTuoTimer = null;
        this.websock.close(); //离开路由之后断开websocket连接
    },
    destroyed() {
        this.websock.close() //离开路由之后断开websocket连接
    }
}
</script>
<style scoped>
  .head-tab-box{
        position: fixed;
        top: 0;
        width: 100%;
        padding: .24rem 0 .3rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #f7f7f7;
    }
    .head-tab-box .tab{
        /* width: 86px; */
        padding: 0 .24rem;
        height: .75rem;
        color: #515151;
        font-size: .42rem;
        line-height: .75rem;
        background: #e2e2e2;
        text-align: center;
    }
    .head-tab-box .tab.active{
        color: #fff;
        background: #218adc;
    }
    .head-tab-box .tab1{
        border-radius: .6rem 0 0 .6rem;
    }
    .head-tab-box .tab2{
        border-radius: 0 .6rem .6rem 0;
    }
    .scroll-box{
        position: absolute;
        top: 2.4rem;
        bottom: 2.1rem;
        width: 100%;
        background: #fafafa;
        overflow-y: scroll;
    }
    .transaction-head{
        position: fixed;
        top: 1.2rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 1.2rem;
        padding: 0 .48rem 0 .36rem;
        color: #000;
        font-size: .48rem;
        line-height: 1.2rem;
        box-sizing: border-box;
        background: #f7f7f7;
    }
    .transaction-head .icon{
        width: .54rem;
        height: .54rem;
    }
    .transaction-head .text{
        flex: 1;
        padding: 0 .54rem;
    }
    .item1-box{
        display: flex;
        align-items: center;
        padding: .72rem .36rem .12rem;
        background: #f7f7f7;
    }
    .item1-box .icon{
        width: 2.52rem;
        height: .72rem;
        color: #fff;
        line-height: .72rem;
        text-align: center;
    }
    .item1-box .icon.icon1{
        background: url("../assets/coin_left_gray.png") no-repeat center center;
        background-size: cover;
    }
    .item1-box .icon1.active{
        background: url("../assets/coin_left_green.png") no-repeat center center;
        background-size: cover;
    }
    .item1-box .icon.icon2{
        margin-left: .3rem;
        background: url("../assets/coin_right_gray.png") no-repeat center center;
        background-size: cover;
    }
    .item1-box .icon2.active{
        margin-left: .3rem;
        background: url("../assets/coin_right_red.png") no-repeat center center;
        background-size: cover;
    }
    .item1-box .item1-right{
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex: 1;
        text-align: right;
    }
    .item1-box .item1-right .t1{
        color: #b53030;
        font-weight: bold;
    }
    .item1-box .item1-right .t2{
        padding-left: .75rem;
        color: #000;
        font-weight: bold;
    }
    .transaction-box{
        display: flex;
        justify-content: space-between;
        align-items: stretch;
        background: #fff;
    }
    .transaction-box .transaction-left{
        flex: 1;
        padding: .42rem .24rem .66rem .42rem;
    }
    .transaction-box .transaction-left .limit-box{
        display: flex;
        align-items: center;
    }
    .transaction-box .transaction-left .limit-box .icon{
        margin-left: .24rem;
        width: .36rem;
        height: .3rem;
    }
    .transaction-box .transaction-left .num-wrap{
        display: flex;
        align-items: center;
        padding: .54rem 0 .66rem;
    }
    .transaction-box .transaction-left .input-box{
        flex: 1;
        border-right: 1px solid #ddd;
    }
    .transaction-box .transaction-left .num-wrap .input{
        width: 100%;
        height: .9rem;
        padding: 0 .12rem;
        color: #000;
        font-size: .48rem;
        line-height: .9rem;
        box-sizing: border-box;
    }
    .transaction-box .transaction-left .num-box{
        display: flex;
        align-items: center;
    }
    .transaction-box .transaction-left .num-wrap .btn{
        display: block;
        width: .9rem;
        height: .9rem;
        color: #969696;
        font-size: .48rem;
        font-weight: bold;
        line-height: .9rem;
        background: #fff;
    }
    .transaction-box .transaction-left .price{
        color: #333;
        font-size: .36rem;
    }
    .transaction-box .transaction-left .percent-box{
        position: relative;
        display: flex;
        align-items: center;
        width: 100%;
        height: .12rem;
        margin: .45rem 0 .15rem;
        box-sizing: border-box;
        background: #E9E9E9;
    }
    .transaction-box .transaction-left .percent-box .percent{
        position: relative;
        width: 24%;
        height: .12rem;
    }
    .transaction-box .transaction-left .percent-box .percent::after{
        position: absolute;
        right: -.12rem;
        top: 50%;
        z-index: 8;
        content: '';
        width: .24rem;
        height: .24rem;
        border-radius: 100%;
        background: #E9E9E9;
        transform: translateY(-50%);
    }
    .transaction-box .transaction-left .percent-box .percent:first-child{
        width: .24rem;
    }
    .transaction-box .transaction-left .percent-box .percent:first-child::after{
        right: 0;
        left: 0;
    }
    .transaction-box .transaction-left .percent-box .percent.active::after{
        width: .36rem;
        height: .36rem;
        border: 2px solid #53A8F1;
        background: #fff;
    }
    .transaction-box .transaction-left .percent-text{
        padding: .12rem 0;
        color: #7f7f7f;
        font-size: .36rem;
        text-align: right;
    }
    .transaction-box .transaction-left .price-box{
        margin: .3rem 0 .36rem;
    }
    .transaction-box .transaction-left .price-box .input{
        width: 100%;
        height: 1.14rem;
        color: #666;
        line-height: 1.14rem;
        background: #eff4f4;
        text-align: center;
    }
    .transaction-box .transaction-left .table .table-head{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .24rem .12rem;
        color: #a3a3a3;
        font-size: .36rem;
        border: 1px solid #d7d7d7;
        border-radius: .12rem;
    }
    .transaction-box .transaction-left .table-head .num-box{
        flex: 1;
    }
    .transaction-box .transaction-left .table-head .num-box .input{
        width: 100%;
        font-size: .36rem;
    }
    .transaction-box .transaction-left .table .table-body{
        display: flex;
        justify-content: space-between;
        align-items: center;
        /* opacity: 0;  */
    }
    .transaction-box .transaction-left .table .td{
        width: 20%;
        padding: .18rem 0;
        color: #a3a3a3;
        font-size: .39rem;
        border: 1px solid #d7d7d7;
        text-align: center;
    }
    .transaction-box .transaction-left .table .td:last-child{
        border-right: none;
    }
    .transaction-box .transaction-left .trade{
        margin-top: .15rem;
        color: #333;
        font-size: .36rem;
    }
    .transaction-box .transaction-left .btn-buy{
        display: block;
        width: 100%;
        height: .9rem;
        margin-top: .3rem;
        color: #fff;
        border-radius: .12rem;
        background: #00c483;
        text-align: center;
    }
    .transaction-box .transaction-left .btn-sell{
        background: #d85656;
    }

    .transaction-box .transaction-right{
        flex: 1;
    }
    .transaction-box .transaction-right .ul-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: .42rem;
        color: #7f7f7f;
    }
    .transaction-box .transaction-right .ul-box .list{
        flex: 1;
        font-size: .36rem;
        text-align: center;
    }
    .transaction-box .transaction-right .ul-box .list-qty{
        flex: 1.5;
    }

    .transaction-box .transaction-right .cont1-box .cont{
        position: relative;
        z-index: 2;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: .24rem;
        color: #d85656;
        font-size: .36rem;
    }
    .transaction-box .transaction-right .cont1-box .cont2 .item{
        color: #00c483;
    }
    .transaction-box .transaction-right .cont1-box .scroll{
        position: absolute;
        right: 0;
        z-index: -1;
        width: 0%;
        height: .9rem;
        background: #fff0f5;
        transition: all 1s ease-in;
    }
    .transaction-box .transaction-right .cont1-box .scroll2{
        position: absolute;
        right: 0;
        z-index: -1;
        width: 0%;
        height: .9rem;
        background: #e9fff6;
        transition: all 1s ease-in;
    }
    .transaction-box .transaction-right .cont1-box .item{
        flex: 1;
        color: #d85656;
        text-align: center;
    }
    .transaction-box .transaction-right .cont1-box .item-number{
        flex: 1.5;
    }
    .transaction-box .transaction-right .line{
        margin: .42rem 0 0;
        height: 1px;
        background: #f0f0f0;
    }
    .transaction-foot{
        margin-top: .24rem;
        padding: 0 .24rem .3rem .42rem;
        background: #fff;
    }
    .transaction-foot .cont-box{
    height: 9.6rem;
    overflow-y: auto;
    }
    .transaction-foot .tab-box{
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: .48rem 0 .18rem;
        color: #b5b5b5;
        font-size: .45rem;
    }
    .transaction-foot .tab-box .tab{
        position: relative;
        width: 33.33%;
        font-size: .39rem;
        text-align: center;
    }
    .transaction-foot .tab-box .active{
        color: #000;
        font-size: .45rem;
    }
    .transaction-foot .tab-box .active::after{
        position: absolute;
        left: 50%;
        bottom: -.12rem;
        content: '';
        width: .6rem;
        height: 2px;
        margin-left: -.3rem;
        background: #4458ed;
    }
    .transaction-foot .cont-box .list{
        margin-top: .6rem;
    }
    .transaction-foot .cont-box .list .list-head{
        display: flex;
        align-items: center;
    }
    .transaction-foot .cont-box .list .buy{
        padding: 1px .12rem;
        color: #fff;
        font-size: .36rem;
        border-radius: .18rem;
        background: #00c483;
    }
    .transaction-foot .cont-box .list .sell{
        background: #d85656;
    }
    .transaction-foot .cont-box .list .type{
        padding: 0 .3rem 0 .24rem;
        color: #000;
        font-weight: bold;
    }
    .transaction-foot .cont-box .list .type span{
        color: #b5b5b5;
        font-size: .39rem;
        font-weight: normal;
    }
    .transaction-foot .cont-box .list .date{
        color: #b5b5b5;
    }
    .transaction-foot .cont-box .list .time{
        flex: 1;
        padding-left: .3rem;
        color: #b5b5b5;
    }
    .transaction-foot .cont-box .list .btn-cancle{
        padding: .12rem .24rem;
        color: #218adc;
        font-size: .36rem;
        border: 1px solid #218adc;
        border-radius: .12rem;
    }
    .transaction-foot .cont-box .list .status{
        color: #b5b5b5;
    }
    .transaction-foot .cont-box .list .list-body .list-item{
        /* display: flex;
        align-items: center; */
        margin-top: .3rem;
        color: #7f7f7f;
    }
    .transaction-foot .cont-box .list .list-body .list-item-left{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .transaction-foot .cont-box .list .list-body .list-item-right{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: .3rem;
        /* margin-left: 30px; */
    }
    .transaction-foot .cont-box .list .list-body .t2{
        margin-top: .3rem;
    }
    .transaction-foot .cont-box .cont1{
        padding: .48rem .36rem;
        color: #666;
        background: #fafafa;
        border-bottom: 1px solid #e0e0e0;
    }
    .transaction-foot .cont-box .cont2{
        padding: .36rem .36rem 0;
        background: #fafafa;
    }
    .transaction-foot .cont-box .cont2 .ul-box .li{
        display: flex;
        align-items: center;
        padding-bottom: .54rem;
        color: #666;
    }
    .transaction-foot .cont-box .cont2 .ul-box .t2{
        flex: 1.5;
        word-break: break-word;
        text-align: right;
    }
    .transaction-foot .cont-box .cont2 .ul-box .t2 a{
      color: #588bf8;
    }
    .alert-box{
        position: absolute;
        bottom: 0;
        z-index: 1000;
        width: 100%;
        background: #fafafa;
    }
    .alert-box .alert-item{
        width: 100%;
        height: 1.44rem;
        color: #000;
        line-height: 1.44rem;
        background: #fff;
        text-align: center;
    }
    .alert-box .alert-item.xj{
        border-bottom: 1px solid #e0e0e0;
    }
    .alert-box .alert-item.active{
        color: #218adc;
    }
    .alert-box .btn-cancle{
        margin-top: .18rem;
    }
    /* 左侧弹窗 */
    .alert-left{
        position: fixed;
        left: 0;
        top: 0;
        z-index: 1000;
        width: 8.1rem;
        height: 100%;
        background: #fff;
    }
    .alert-left .tab-box{
        position: fixed;
        top: 0;
        left: 0;
        width: 7.38rem;
        display: flex;
        align-items: center;
        margin: 0 .36rem;
        padding: .96rem 0 0;
        color: #7f7f7f;
        font-size: .48rem;
        border-bottom: 1px solid #e0e0e0;
        box-sizing: border-box;
    }
    .alert-left .tab-box .tab{
        padding-bottom: .27rem;
    }
    .alert-left .tab-box .active{
        color: #218adc;
        border-bottom: 2px solid #218adc;
    }
    .alert-left .tab-box .tab:first-child{
        margin-right: .96rem;
    }
    .alert-left .ul-box{
        position: absolute;
        top: 1.86rem;
        bottom: 0;
        width: 100%;
        height: auto;
    }
    .alert-left .ul-box .list .list-box{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0 .36rem;
        padding: .36rem .18rem .36rem 0;
        border-bottom: 1px solid #e0e0e0;
    }
    .alert-left .ul-box .list.active{
        background: #f0f5f7;
    }
    .alert-left .ul-box .list.active .list-box{
        border: none;
    }
    .alert-left .ul-box .list .t1{
        color: #000;
        font-weight: bold;
    }
    .alert-left .ul-box .list .t1 span{
        color: #aaa;
        font-size: .36rem;
        font-weight: normal;
    }
    .alert-left .ul-box .list .price{
        color: #d85656;
    }
</style>



// WEBPACK FOOTER //
// src/pages/currencyTrading.vue